
import { Component, Vue } from 'vue-property-decorator'
import { isPhone } from '@/utils/validate'
import axios from 'axios'
import {
  apiAgentSendCode,
  apiAgentMobileCodeRegister,
  apiAgentWechatRegister,
  apiAgentCheckAgent
} from '../api'
import { phone } from '@/utils/filters'
import { getQueryVariable, isIOS, openScheme, toAppMarketEnjoy } from '@/utils'
@Component
export default class extends Vue {
  WX_APP_ID = 'wx1dac46863ccb082b'
  WX_SECRET = '75d118b3cb99ff15d4055764325b0abd'
  isWeiXin = navigator.userAgent.toLowerCase().includes('micromessenger') // 判断是否是微信浏览器
  agentNo = this.$route.query.agentNo || ''
  loginForm = {
    code: '',
    phone: ''
  }

  isAgree = false
  showPopover = false
  get sendCodeText() {
    if (this.times < 60) {
      return this.times + '秒'
    } else {
      return '发验证码'
    }
  }
  times = 60
  sendCodeTimer: any = null
  sendLoading = false
  btnLoading = false
  registerType = 1
  showRegistered = false
  showWxPop = false
  get canSendCode() {
    return this.loginForm.phone.length === 11 && this.times === 60
  }
  get canLogin() {
    return (
      this.loginForm.phone.length === 11 &&
      this.loginForm.code.length === 6 &&
      this.isAgree
    )
  }
  handlAgree() {
    this.isAgree = !this.isAgree
    if (this.isAgree) {
      this.showPopover = false
    }
  }
  toAgreement(id: number) {
    window.location.href =
      'https://web.wlwyl.com/h5/main/user.html#/richH5?id=' + id
  }
  async checkAgent() {
    try {
      const { data } = await apiAgentCheckAgent({
        agentNo: this.agentNo
      })
      if (!data) {
        this.$router.push({
          path: '/registerSuccess'
        })
      }
    } catch (e) {
      this.$toast.clear()
      this.$router.push({
        path: '/registerSuccess'
      })
    }
  }
  async sendCode() {
    if (this.sendLoading) return
    if (isPhone(this.loginForm.phone) === false) {
      this.$toast('请输入正确的手机号')
      return
    }
    this.sendLoading = true

    if (this.times != 60) return

    try {
      //
      await apiAgentSendCode({
        phone: this.loginForm.phone
      })
      this.$toast('验证码发送成功')
      this.sendCodeTimer = setInterval(() => {
        this.times--
        if (this.times <= 0) {
          clearInterval(this.sendCodeTimer)
          this.times = 60
        }
      }, 1000)
    } catch (e) {
      const err: any = e
      if (err.code == 80001) {
        this.$toast.clear()
        this.showRegistered = true
      }
    } finally {
      this.sendLoading = false
    }
  }
  handleCommit() {
    this.isAgree = true
    this.showPopover = false
    if (this.registerType == 1) {
      this.phoneRegister()
    } else {
      this.jumpWxAuth()
    }
  }
  jumpWxAuth() {
    this.registerType = 2
    if (!this.isAgree) {
      this.showPopover = true
      return
    }
    const redirectUrl = encodeURIComponent(window.location.href)
    const appid = this.WX_APP_ID
    const response_type = 'code'
    const scope = 'snsapi_userinfo'
    const wxUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=${response_type}&scope=${scope}&state=STATE#wechat_redirect`
    window.location.href = wxUrl
  }
  async handleWxRegister() {
    const code = getQueryVariable('code')
    if (!code) {
      return
    }

    //todo
    try {
      const { data } = await apiAgentWechatRegister({
        agentNo: this.agentNo,
        code: code
      })
      this.$router.replace({
        path: '/registerSuccess',
        query: {
          isSuccess: '1'
        }
      })
    } catch (e) {
      const err: any = e
      if (err.code == 950001) {
        this.$toast.clear()
        this.showRegistered = true
      }
    }
  }

  async phoneRegister() {
    this.registerType = 1
    if (
      this.loginForm.phone.length === 11 &&
      this.loginForm.code.length === 6 &&
      !this.isAgree
    ) {
      this.showPopover = true
    }
    if (!this.canLogin) return
    if (this.btnLoading) {
      return
    }
    this.btnLoading = true
    setTimeout(() => {
      this.btnLoading = false
    }, 2000)
    const params = {
      agentNo: this.agentNo,
      code: this.loginForm.code,
      phone: this.loginForm.phone
    }
    const { data } = await apiAgentMobileCodeRegister(params)
    this.$router.replace({
      path: '/registerSuccess',
      query: {
        isSuccess: '1'
      }
    })
  }

  async iosDownload() {
    //zzsk.app://com.zzsk.app
    try {
      await openScheme(`zzsk.app://com.zzsk.app`, 5000)
    } catch (error) {
      console.log('openScheme error', error)
      window.location.href = 'https://itunes.apple.com/app/id6479635137'
    }
  }
  async androidDownload() {
    try {
      await openScheme(`kigo.enjoy://com.kigo.enjoy`, 3000)
    } catch (error) {
      console.log('openScheme error', error)
      toAppMarketEnjoy('daili')
    }
  }

  handlDownload() {
    this.$router.push({
      path: '/registerSuccess'
    })
  }
  created() {
    console.log('query', getQueryVariable('code'))
    this.handleWxRegister()
    this.checkAgent()
  }
}
